if (!window.SeranovaTracking) {
  window.SeranovaTracking = (() => {
    const STORAGE_KEY = 'seranova:utm-params';
    const PARAM_PREFIX = 'cc_custom_';

    // Trybe's creator code rides along with the UTM/tw_ params so that creator
    // sales made on the Checkout Champ checkout can be attributed.
    const TRYBE_KEY = 'trybe';

    function isTrackedKey(key) {
      return key.startsWith('tw_') || key.startsWith('utm_') || key === TRYBE_KEY;
    }

    function getSourceParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const sourceParams = [];

      for (const [key, value] of urlParams.entries()) {
        if (isTrackedKey(key) && value !== '') {
          sourceParams.push([key, value]);
        }
      }

      if (sourceParams.length) {
        saveSourceParams(sourceParams);
        return sourceParams;
      }

      return getStoredSourceParams();
    }

    function getStoredSourceParams() {
      try {
        const rawValue = window.sessionStorage.getItem(STORAGE_KEY);

        if (!rawValue) {
          return [];
        }

        const parsedValue = JSON.parse(rawValue);

        if (!parsedValue || typeof parsedValue !== 'object' || Array.isArray(parsedValue)) {
          return [];
        }

        return Object.entries(parsedValue).filter(
          ([key, value]) => isTrackedKey(key) && typeof value === 'string' && value,
        );
      } catch (error) {
        return [];
      }
    }

    function saveSourceParams(sourceParams) {
      try {
        const payload = {};
        sourceParams.forEach(([key, value]) => {
          payload[key] = value;
        });
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      } catch (error) {
        // Ignore storage failures.
      }
    }

    function appendParams(url) {
      if (!url) {
        return url;
      }

      const sourceParams = getSourceParams();

      if (!sourceParams.length) {
        return url;
      }

      let parsedUrl;

      try {
        parsedUrl = new URL(url, window.location.origin);
      } catch (error) {
        return url;
      }

      sourceParams.forEach(([key, value]) => {
        const trackingKey = `${PARAM_PREFIX}${key}`;

        if (!parsedUrl.searchParams.has(trackingKey)) {
          parsedUrl.searchParams.append(trackingKey, value);
        }

        // Trybe's pixel reads a parameter named exactly "trybe" — it cannot see
        // the cc_custom_-prefixed copy. Send both: cc_custom_trybe is stored on
        // the Checkout Champ order, plain trybe is what the pixel reads.
        if (key === TRYBE_KEY && !parsedUrl.searchParams.has(TRYBE_KEY)) {
          parsedUrl.searchParams.append(TRYBE_KEY, value);
        }
      });

      return parsedUrl.toString();
    }

    return {
      appendParams,
      getSourceParams,
    };
  })();
}
